import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetCallQualityEvaluationComponent } from '@wephone-app-phone/modals/bottom-sheet-call-quality-evaluation/bottom-sheet-call-quality-evaluation.component';
import { IPhoneCall } from './phone/phonecall.i';

@Injectable()
export class CallEvaluationService {

  constructor(
    private bottomSheet: MatBottomSheet
  ) {
  }

  endCallOpenCallQualityEvaluation(call: IPhoneCall): any {
    this.bottomSheet.open(BottomSheetCallQualityEvaluationComponent, { data: { calldata: call.calldata } });
  }
}
